import {URL_BASE} from "../../../Globals.ts";

export const getFilteredFiles = async (query: string, files: string[], returnedFileContents: any[]) => {
    let filteredFiles = returnedFileContents;

    try {
        const url = `${URL_BASE}/api/filterFiles`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ query: query, files: files })
        });

        if (response.ok) {
            const keptIndices = await response.json();
            filteredFiles = keptIndices.map((index: number) => returnedFileContents[index]);
        }

        return filteredFiles;
    } catch (error) {
        console.error(`Error getting filtered files: ${error}`);
        return filteredFiles;
    }
}
